import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/pic_search.png';
import _imports_1 from '@/assets/imgs/pic_edit.png';
import _imports_2 from '@/assets/imgs/pic_del.png';

const _withScopeId = n => (_pushScopeId("data-v-512878d4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "upload_area"
};
const _hoisted_2 = {
  class: "upload-area"
};
const _hoisted_3 = {
  key: 1,
  class: "avatar-uploader"
};
const _hoisted_4 = {
  class: "operation"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "upload-tips"
};
const _hoisted_7 = {
  class: "sm_upload_area"
};
const _hoisted_8 = {
  key: 1,
  class: "sm_avatar_uploader"
};
const _hoisted_9 = {
  class: "operation"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "sm_upload_tips"
};
const _hoisted_12 = ["src", "alt"];
import { Plus } from '@element-plus/icons-vue';
import { nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import UploadPic from './uploadPic.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'uploadForm',
  props: {
    picObj: {
      default: () => {},
      type: Object || Array
    },
    mode: {
      // 上级表单的模式 add||edit
      default: 'add',
      type: String
    }
  },
  emits: ['update:bigIcon', 'updatePicObj'],

  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const mform = ref();
    const formModel = ref({
      icon: {
        fileURL: '',
        name: ''
      },
      agentLogo: {
        fileURL: '',
        name: ''
      }
    });
    const uploadObj = ref({
      visible: false,
      url: '',
      type: 0 //0 iptvLogo 1 agentLogo

    });
    expose({
      mform
    });
    const bigPicData = reactive({
      visible: false,
      url: ''
    }); //监听图片url的变化，通知父组件修改传入这个子组件的url

    watch(() => uploadObj.value.url, (newVal, oldVal) => {
      if (newVal) {
        emit('updatePicObj', newVal, uploadObj.value.type); // mform.value.validate((valid,fields) => {})

        let validString = uploadObj.value.type == 0 ? 'icon' : 'agentLogo';
        mform.value.validateField(validString);
      }
    });
    watch(() => props.picObj, newVal => {
      console.log('组件传入的数据', newVal);

      if (newVal) {
        formModel.value = newVal;
      }
    }, {
      immediate: true,
      deep: true
    });

    const previewBigPic = type => {
      // type:0 iptvLogo 1 agentLogo
      //查看大图
      bigPicData.visible = true; // bigPicData.url = formModel.value.icon.fileURL

      bigPicData.url = type === 0 ? formModel.value.icon.fileURL : formModel.value.agentLogo.fileURL;
      console.log('big', bigPicData.url);
    };

    const deletePic = (data, type) => {
      // 删除图片
      bigPicData.visible = false;
      bigPicData.url = '';
      uploadObj.value.type = type; //记录删除的是哪个图片

      uploadObj.value.url = '';

      if (type === 0) {
        formModel.value.icon.fileURL = '';
        formModel.value.icon.name = '';
      } else {
        formModel.value.agentLogo.fileURL = '';
        formModel.value.agentLogo.name = '';
      }

      emit('updatePicObj', [formModel.value.icon.fileURL, formModel.value.agentLogo.fileURL], uploadObj.value.type = type);
      nextTick(() => {
        //手动触发图片区域的校验
        mform.value.validate((valid, fields) => {});
      });
    };

    const validImg = (rule, value, callback) => {
      if (!value.fileURL || value.fileURL === '') return callback(new Error(t('请上传图片')));
      callback();
    };

    const imgRules = reactive({
      icon: [{
        required: true,
        validator: validImg,
        trigger: 'change'
      }],
      agentLogo: [{
        required: false,
        validator: validImg,
        trigger: 'change'
      }]
    }); // 打开对话框上传图片

    const onUploadPic = type => {
      uploadObj.value.visible = true;
      uploadObj.value.url = '';
      uploadObj.value.type = type;
    }; // 编辑图片


    const onEditPic = (data, type) => {
      console.log('编辑图片', data, type);
      uploadObj.value.type = type;
      uploadObj.value.url = data.fileURL;
      uploadObj.value.visible = true;
    };

    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
        ref_key: "mform",
        ref: mform,
        model: formModel.value,
        rules: imgRules,
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "icon",
          ref: "imgItemRef",
          class: "bg_form"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [!formModel.value.icon.fileURL ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "avatar-uploader",
            onClick: _cache[0] || (_cache[0] = $event => onUploadPic(0))
          }, [_createVNode(_component_el_icon, {
            class: "avatar-uploader-icon"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          })])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
            src: _imports_0,
            alt: "",
            onClick: _cache[1] || (_cache[1] = $event => previewBigPic(0))
          }), _createElementVNode("img", {
            src: _imports_1,
            alt: "",
            onClick: _cache[2] || (_cache[2] = $event => onEditPic(formModel.value.icon, 0))
          }), _createElementVNode("img", {
            src: _imports_2,
            alt: "",
            onClick: _cache[3] || (_cache[3] = $event => deletePic(formModel.value.icon, 0))
          })]), _createElementVNode("img", {
            src: formModel.value.icon.fileURL,
            class: "avatar"
          }, null, 8, _hoisted_5)])), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('IPTV图标')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('尺寸')) + ": 200*200px", 1)])])]),
          _: 1
        }, 512), _createVNode(_component_el_form_item, {
          prop: "agentLogo",
          ref: "imgItemRef",
          class: "sm_form"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [!formModel.value.agentLogo.fileURL ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "sm_avatar_uploader",
            onClick: _cache[4] || (_cache[4] = $event => onUploadPic(1))
          }, [_createVNode(_component_el_icon, {
            class: "avatar-uploader-icon"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          })])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
            src: _imports_0,
            alt: "",
            onClick: _cache[5] || (_cache[5] = $event => previewBigPic(1))
          }), _createElementVNode("img", {
            src: _imports_1,
            alt: "",
            onClick: _cache[6] || (_cache[6] = $event => onEditPic(formModel.value.agentLogo, 1))
          }), _createElementVNode("img", {
            src: _imports_2,
            alt: "",
            onClick: _cache[7] || (_cache[7] = $event => deletePic(formModel.value.agentLogo, 1))
          })]), _createElementVNode("img", {
            src: formModel.value.agentLogo.fileURL,
            class: "sm_avatar"
          }, null, 8, _hoisted_10)])), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('客户图标')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('尺寸')) + ": 200*200px", 1)])])]),
          _: 1
        }, 512)]),
        _: 1
      }, 8, ["model", "rules"])]), _createVNode(_component_el_dialog, {
        modelValue: bigPicData.visible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => bigPicData.visible = $event)
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          style: {
            "width": "100%"
          },
          "w-full": "",
          src: bigPicData.url,
          alt: _ctx.$t('Preview Image')
        }, null, 8, _hoisted_12)]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(UploadPic, {
        modelValue: uploadObj.value.visible,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => uploadObj.value.visible = $event),
        url: uploadObj.value.url,
        "onUpdate:url": _cache[10] || (_cache[10] = $event => uploadObj.value.url = $event),
        type: uploadObj.value.type
      }, null, 8, ["modelValue", "url", "type"])], 64);
    };
  }

});